import type Schema from 'validate';

function validateVersion(data: Record<string, unknown>): string | null {
    if (typeof data.version !== 'number') {
        return 'Missing version number ';
    }
    return null;
}

function validateSchema(
    data: Record<string, unknown>,
    schema: Schema,
): string | null {
    const results = schema
        .validate(data, { strip: false })
        // @ts-expect-error - badly implemented error object in validate library
        .map((result: Error) => result.message)
        .join(', ');
    return results.length ? `Schema validation failed: ${results}` : null;
}

export function traDataValidator(
    data: Record<string, unknown>,
    schema: Schema,
): string | null {
    const validators: (string | null)[] = [
        validateVersion(data),
        validateSchema({ ...data }, schema),
    ];
    return validators.find((error) => error !== null) ?? null;
}
